import moment from "moment-timezone";

// The whole app must work in Iran time regardless of the user's device timezone,
// so the web matches the backend (which always reports in Asia/Tehran). Without
// this, a user whose device is on another timezone (e.g. a remote worker on
// London time) enters and sees shifted times, disagreeing with the server report.
//
// moment, moment-jalaali and moment-timezone all extend the same moment
// singleton, so this single call pins every moment()/moment-jalaali() usage to
// Tehran. Import this module before anything else (see index.tsx).
export const APP_TIMEZONE = "Asia/Tehran";

moment.tz.setDefault(APP_TIMEZONE);

export default moment;
